<template>
  <div>
    <!-- 新版首页轮播图特效 -->
    <div class="list_swiper_container">
      <div class="list_swiper">
        <div class="list_box_left">头条资讯</div>
        <div class="list_box_right">
          <swiper height="9.7rem" :auto="true" :loop="true" :interval="6000">
            <!--  -->
            <swiper-item
              class="black"
              v-for="(item, index) in list"
              :key="index"
            >
              <div
                v-for="(item, index) in list[index]"
                :key="index"
                :class="['swiper_everyone', index == 3 ? '' : 'vux-1px-b']"
                @click="jump(item)"
              >
                <div class="left_box">
                  <p class="left_title" v-html="seachFifter(item.title)"></p>
                  <div class="left_bottom">
                    <div>
                      <img :src="item.logoUrl" alt="" v-if="item.logoUrl" />
                      <span class="r_b_l_text">{{ item.source }}</span>
                    </div>
                    <span v-show="ifShare == 2" class="readYsh">
                      <span class="readNum">{{ item.readNum || 0 }}</span>
                      {{ path == 'headlineDetail' ? '位同行阅读' : '' }}
                    </span>
                    <span v-show="ifShare == 1" class="readYsh">
                      打开医生汇阅读
                    </span>
                  </div>
                </div>
                <div class="right_img_box">
                  <img :src="item.coverUrl" alt="" />
                </div>
              </div>
            </swiper-item>
          </swiper>
        </div>
      </div>
      <p class="more_list_information" @click="goMoreToLine">
        更多资讯
        <img
          src="http://cdn.yxvzb.com/WEB/wx-master/images/pic/index_right.png"
          alt=""
        />
      </p>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperItem } from 'vux';
export default {
  name: '',
  props: {
    needHighlight: {
      type: Boolean,
      default: false
    },
    keys: {
      type: String,
      default: '特殊'
    },
    path: {
      default: 'headlineDetail'
    },

    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    ifShare: {
      // 是否为分享落地页
      type: Number,
      default: 2
    }
  },
  data() {
    return {};
  },
  methods: {
    seachFifter(content) {
      if (this.needHighlight) {
        let filtercontent = content.replace(/<|>/g, '');
        return filtercontent.replace(
          new RegExp(this.keys, 'g'),
          '<span class=\'colorRed\'>' + this.keys + '</span>'
        );
      } else {
        return content;
      }
    },
    goYsh() {
      window.location =
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
    },
    jump(item) {
      //        location.href = `${this.$config.urlPath}${this.path}/${item.id}?type=${this.type}`
      if (this.$route.query.shareFlag) {
        this.$router.push({
          name: this.path,
          params: { id: item.id },
          query: { type: item.type, shareFlag: true }
        });
      } else {
        this.$router.push({
          name: this.path,
          params: { id: item.id },
          query: { type: item.type }
        });
      }
    },
    goMoreToLine() {
      this.$router.push({ name: 'headlineList' });
    }
  },
  computed: {},
  components: {
    Swiper,
    SwiperItem
  },
  mounted() {},
  filters: {
    heighLight: function(v) {
      return v + '<span>123</span>';
    }
  }
};
</script>
<style lang="less" scoped>
.list_swiper_container {
  border-bottom: 0.19rem solid #f4f4f4;
  .list_swiper {
    padding: 0 0 0.5rem 0.43rem;
    display: flex;
    justify-content: space-between;
    .list_box_left {
      margin-top: 0.72rem;
      display: flex;
      align-items: center;
      width: 8%;
      font-size: 0.43rem;
      color: #027cfa;
      font-weight: bold;
      border-right: 0.01rem solid #d2d1d1;
    }
    .list_box_right {
      margin: 0 0 0 2%;
      width: 90%;
      .black {
        padding-top: 0.39rem;
        .swiper_everyone {
          // padding-left: .45rem;
          padding: 0.18rem 0 0.28rem 0.45rem;
          display: flex;
          justify-content: space-between;
          align-items: space-between;
          width: 8rem;
          height: 25.8%;
          .left_box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 5rem;
            .left_title {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 0.37rem;
              color: #191919;
            }
            .left_bottom {
              margin-top: 0.19rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              div {
                width: 2.4rem;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                img {
                  width: 0.4rem;
                }
                .r_b_l_text {
                  font-size: 0.27rem;
                  color: #999999;
                }
              }
              .readYsh {
                display: flex;
                width: 2.6rem;
                font-size: 0.27rem;
                color: #565656;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                .readNum {
                  width: 1.8rem;
                  text-align: right;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
              }
            }
          }
          .right_img_box {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 2.4rem;
            img {
              padding-bottom: 0.1rem;
              width: 2.13rem;
            }
          }
        }
      }
    }
  }
  .more_list_information {
    margin: 0.53rem auto 0.45rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.4rem;
    color: #027cfa;
    img {
      margin-left: 0.19rem;
      width: 0.16rem;
    }
  }
}
</style>
<style lang="less">
.list_box_right > .vux-slider {
  overflow: visible !important;
}
.list_box_right > .vux-slider > .vux-indicator {
  position: absolute !important;
  bottom: -0.8rem !important;
  text-align: center !important;
  padding-right: 1.3rem !important;
}
.list_box_right > .vux-slider > .vux-indicator > a > .vux-icon-dot,
.vux-slider .vux-indicator-right > a > .vux-icon-dot {
  width: 0.19rem !important;
  height: 0.19rem !important;
  background: #d2d2d2 !important;
  border: none !important;
}
.list_box_right > .vux-slider > .vux-indicator > a > .vux-icon-dot.active,
.vux-slider .vux-indicator-right > a > .vux-icon-dot,
.active {
  background: #268ffb !important;
}
</style>
